export const PRIME_RECEIPTS_STATE = 'primeReceipts'

export const PRIME_RECEIPTS_REQUEST = 'PRIME_RECEIPTS_REQUEST'
export const PRIME_RECEIPTS_SUCCESS = 'PRIME_RECEIPTS_SUCCESS'
export const PRIME_RECEIPTS_FAILURE = 'PRIME_RECEIPTS_FAILURE'
